import * as tslib_1 from "tslib";
import React from 'react';
import { Url, URLS } from '@wix/da-url';
import { withTranslation } from 'react-i18next';
import { ModalType } from '../../../Modals/redux/types';
import Button from '../../../Button';
import StandardMenu from '../../../Dropdown/Preset/StandardMenu';
import classnames from 'classnames';
import { BiEventType, BiLink, BiSpan } from '../../../biLogger';
import HoverComponent from '../../_partials/HoverComponent/HoverComponent';
import { withVerification, } from '../../../VerificationPopup/withVerification';
import s from './SubmitMenu.scss';
var configHoverComponent = function (translate, svg) { return ({
    componentHover: {
        svg: svg,
        title: translate + ".title",
        context: translate + ".context",
    },
}); };
var SubmitMenu = /** @class */ (function (_super) {
    tslib_1.__extends(SubmitMenu, _super);
    function SubmitMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitMenuItems = [
            tslib_1.__assign({ label: 'siteHeader.deviation', link: URLS.SUBMIT, componentClass: BiLink, componentProps: {
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        menu_item: 'deviation',
                        menu_name: 'submit',
                        link_url: URLS.SUBMIT,
                    },
                } }, configHoverComponent('siteHeader.deviation', 'deviant')),
            tslib_1.__assign({ label: 'siteHeader.statusUpdate', verificationAction: 'submitstatus' }, _this.getItemProps(ModalType.STATUS_UPDATE), configHoverComponent('siteHeader.statusUpdate', 'status')),
            tslib_1.__assign({ label: 'siteHeader.journal', verificationAction: 'submitjournal' }, _this.getItemProps(ModalType.JOURNAL), configHoverComponent('siteHeader.journal', 'journal')),
            tslib_1.__assign({ label: 'siteHeader.literature' }, _this.getItemProps(ModalType.LITERATURE), configHoverComponent('siteHeader.literature', 'literature')),
            tslib_1.__assign({ label: 'siteHeader.poll', verificationAction: 'submitpoll' }, _this.getItemProps(ModalType.POLL_EDIT), configHoverComponent('siteHeader.poll', 'poll')),
            tslib_1.__assign({ label: 'siteHeader.motion', link: URLS.SUBMIT_MOTIONBOOK, target: '_blank', componentClass: BiLink, componentProps: {
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        menu_item: 'motion_book',
                        menu_name: 'submit',
                        link_url: URLS.SUBMIT_MOTIONBOOK,
                    },
                } }, configHoverComponent('siteHeader.motion', 'motionBook')),
            tslib_1.__assign({ label: 'siteHeader.daMuro', link: URLS.SUBMIT_MURO, target: '_blank', componentClass: BiLink, componentProps: {
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        menu_item: 'da_muro',
                        menu_name: 'submit',
                        link_url: URLS.SUBMIT_MURO,
                    },
                } }, configHoverComponent('siteHeader.daMuro', 'muro')),
        ];
        _this.getMenuItem = function (_a) {
            var label = _a.label, onClick = _a.onClick, target = _a.target, componentClass = _a.componentClass, componentProps = _a.componentProps, componentHover = _a.componentHover, _b = _a.verificationAction, verificationAction = _b === void 0 ? 'submit' : _b, link = _a.link;
            var _c = _this.props, t = _c.t, useSubmitHover = _c.useSubmitHover, isVerificationNeeded = _c.isVerificationNeeded, pushVerificationPopup = _c.pushVerificationPopup;
            var itemLabel = {
                label: (React.createElement(React.Fragment, null,
                    t(label),
                    useSubmitHover && (React.createElement(HoverComponent, tslib_1.__assign({}, componentHover, { className: s['hover-component'] }))))),
                title: t(label),
            };
            // if verification needed, everything is a modal
            if (isVerificationNeeded) {
                return tslib_1.__assign({}, itemLabel, { onClick: function () { return pushVerificationPopup(verificationAction); }, componentClass: BiSpan, componentProps: componentProps });
            }
            return tslib_1.__assign({}, itemLabel, { onClick: onClick,
                link: link,
                target: target,
                componentClass: componentClass,
                componentProps: componentProps });
        };
        return _this;
    }
    SubmitMenu.prototype.getItemProps = function (type) {
        var _a;
        var _b = this.props, redirectOnSubmit = _b.redirectOnSubmit, showSubmitModal = _b.showSubmitModal;
        var types = (_a = {},
            _a[ModalType.STATUS_UPDATE] = 'status',
            _a[ModalType.JOURNAL] = 'journal',
            _a[ModalType.LITERATURE] = 'literature',
            _a[ModalType.POLL_EDIT] = 'poll',
            _a);
        var biData = {
            evid: BiEventType.TOP_NAV_MENU_CLICK,
            menu_item: types[type],
            menu_name: 'submit',
        };
        if (redirectOnSubmit) {
            var url = Url.browseHomeLink() + "?submit_modal=" + types[type];
            return {
                link: url,
                componentClass: BiLink,
                componentProps: {
                    biData: tslib_1.__assign({ link_url: url }, biData),
                },
            };
        }
        return {
            onClick: function () { return showSubmitModal(type); },
            componentClass: BiSpan,
            componentProps: { biData: biData },
        };
    };
    SubmitMenu.prototype.render = function () {
        var _a = this.props, className = _a.className, t = _a.t, isOpen = _a.isOpen;
        return (React.createElement("div", { className: classnames(s['submit-dropdown'], isOpen && s['active'], className), onClick: this.props.onClick, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave },
            React.createElement("div", { className: s['submit-button-link-wrapper'] },
                React.createElement(Button, { view: "b0", className: s['submit-button'] }, t('siteHeader.submit'))),
            isOpen && (React.createElement(StandardMenu, { lightText: true, className: s['submit-menu'], withPaddings: false, menuClassName: s['submit-menu-menu'], itemClassName: s['submit-menu-item'], items: this.submitMenuItems.map(this.getMenuItem) }))));
    };
    return SubmitMenu;
}(React.Component));
export default withVerification(withTranslation()(SubmitMenu));
//# sourceMappingURL=SubmitMenu.js.map